import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";
import "../Gallery.css";

const CbseFootballEastZone = () => {
  const numbers = [1, 2, 3];
  // const i;
  const listItems = numbers.map((number, index) => {
    if (index % 3 === 0)
      return (
        <Row>
          <Col md={4}>
            <div className="mbox">
              <Item
                original={`${"http://www.mpsckp.com/gallery/cbse_football_2024/"}${number}${".jpg"}`}
                thumbnail={`${"http://www.mpsckp.com/gallery/cbse_football_2024/"}${number}${".jpg"}`}
                width="1024"
                height="768"
                className="img-fluid"
              >
                {({ ref, open }) => (
                  <img
                    ref={ref}
                    onClick={open}
                    src={`${"http://www.mpsckp.com/gallery/cbse_football_2024/"}${number}${".jpg"}`}
                    className="img-fluid"
                    alt=""
                  />
                )}
              </Item>
            </div>
          </Col>
          <Col md={4}>
            <div className="mbox">
              <Item
                original={`${"http://www.mpsckp.com/gallery/cbse_football_2024/"}${
                  number + 1
                }${".jpg"}`}
                thumbnail={`${"http://www.mpsckp.com/gallery/cbse_football_2024/"}${
                  number + 1
                }${".jpg"}`}
                width="1024"
                height="768"
                className="img-fluid"
              >
                {({ ref, open }) => (
                  <img
                    ref={ref}
                    onClick={open}
                    src={`${"http://www.mpsckp.com/gallery/cbse_football_2024/"}${
                      number + 1
                    }${".jpg"}`}
                    className="img-fluid"
                    alt=""
                  />
                )}
              </Item>
            </div>
          </Col>
          <Col md={4}>
            <div className="mbox">
              <Item
                original={`${"http://www.mpsckp.com/gallery/cbse_football_2024/"}${
                  number + 2
                }${".jpg"}`}
                thumbnail={`${"http://www.mpsckp.com/gallery/cbse_football_2024/"}${
                  number + 2
                }${".jpg"}`}
                width="1024"
                height="768"
                className="img-fluid"
              >
                {({ ref, open }) => (
                  <img
                    ref={ref}
                    onClick={open}
                    src={`${"http://www.mpsckp.com/gallery/cbse_football_2024/"}${
                      number + 2
                    }${".jpg"}`}
                    className="img-fluid"
                    alt=""
                  />
                )}
              </Item>
            </div>
          </Col>
        </Row>
      );
    else {
      return "";
    }
  });

  return (
    <div className="inner-body">
      <Container fluid>
        <Row className="inner">
          <div className="inner-head-outer">
            <div className="inner-head">
              <Col>
                <h2>CBSE Football Tournament East Zone 2024</h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="../">
                    <i className="fa fa-home"></i> Home
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to={"/mgallery"}>
                      <i className="fa fa-camera"></i> Gallery
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>
                    CBSE Football Tournament East Zone 2024
                  </Breadcrumb.Item>
                </Breadcrumb>
              </Col>
              <Col>
                <blockquote>
                <h5>UNDER -17 BOYS CATEGORY:</h5>
                <h6>WINNERS' TROPHY🏆 - GOLD MEDAL🥇</h6>

                <h5>UNDER -14 BOYS CATEGORY:</h5>
                <h6>BRONZE MEDAL🥉</h6>
                </blockquote>
              </Col>
            </div>
          </div>
        </Row>
      </Container>
      <div className="mib relative">
        <div className="leftline"></div>

        <div className="bottomline"></div>
        <Container>
          <Gallery>{listItems}</Gallery>
        </Container>
      </div>
    </div>
  );
};

export default CbseFootballEastZone;
